import { find, findMany, on } from '../helpers';

// Find all elements with the '[data-block]' attribute
const blockContent = findMany('[data-content-block="container"]');

// Function to append content to a target container
const appendCTA = (targetContainer, content) => {
    targetContainer.appendChild(content);
};

// Function to reset content by checking if it's within the context container and then appending it to the target container
const resetCTA = (contextContainer, targetContainer, content) => {
    if (contextContainer.contains(content)) {
        appendCTA(targetContainer, content);
    }
};

// Function to handle changes in viewport width
const handleViewportWidthChange = (contextContainer, targetContainer, content) => {
    // Check if the viewport width is less than 768 pixels, indicating mobile view
    const isMobile = window.innerWidth < 768;

    // Reset the content (move it) or append it based on the viewport width
    resetCTA(contextContainer, targetContainer, content);

    if (isMobile) {
        // If it's a mobile view, append the content
        appendCTA(contextContainer, content);
    }
};

// Loop through all elements with '[data-block]'
blockContent.forEach(block => {
    // Find all elements with '[data-column]' within the block
    const columns = findMany('[data-content-block="column"]', block);

    // Iterate through columns
    columns.forEach(column => {
        // Find the element with '[data-cta]' within the column
        const cta = find('[data-content-block="buttons"]', column);

        if (cta) {
            // Handle viewport width changes for the CTA
            handleViewportWidthChange(block, column, cta);

            // Attach a resize event listener to update CTA positioning on window resize
            on('resize', () => handleViewportWidthChange(block, column, cta), window);
        }
    });
});
